export const PAGE_SIZE = 10

export const SIZE_MIN = 0
export const SIZE_MAX = 1000

export const PRICE_MIN = 0
export const PRICE_MAX = 500000
export const PRICE_STEP = 1000

export const FLOOR_THRESHOLD = 8

export const ROOM_STATUS_OPTIONS = [
  {
    value: undefined,
    label: { en: 'All', th: 'ทั้งหมด' },
  },
  {
    value: 'available',
    label: { en: 'Available', th: 'ว่าง' },
  },
]

export const ROOM_TYPE_OPTIONS = [
  {
    value: undefined,
    label: { en: 'All', th: 'ทั้งหมด' },
  },
  {
    value: 0,
    label: { en: 'Studio', th: 'สตูดิโอ' },
  },
  {
    value: 1,
    label: { en: '1 Bedroom', th: '1 ห้องนอน' },
  },
  {
    value: 2,
    label: { en: '2 Bedrooms', th: '2 ห้องนอน' },
  },
  {
    value: 3,
    label: { en: '3 Bedrooms', th: '3 ห้องนอน' },
  },
]

export const FLOOR_OPTIONS = [
  {
    value: undefined,
    label: { en: 'All', th: 'ทั้งหมด' },
  },
  {
    value: 'low',
    label: {
      en: `Low (1 to ${FLOOR_THRESHOLD})`,
      th: `ล่าง (1 ถึง ${FLOOR_THRESHOLD})`,
    },
  },
  {
    value: 'high',
    label: {
      en: `High (> ${FLOOR_THRESHOLD})`,
      th: `บน (> ${FLOOR_THRESHOLD})`,
    },
  },
]

export const FURNITURE_OPTIONS = [
  {
    value: undefined,
    label: { en: 'All', th: 'ทั้งหมด' },
  },
  {
    value: 'furnished',
    label: { en: 'Furnished', th: 'ตกแต่ง' },
  },
  {
    value: 'empty',
    label: { en: 'Empty', th: 'ว่าง' },
  },
]
